import React from 'react';
import { Helmet } from 'react-helmet-async';

const truncate = (text, max = 160) => {
  if (!text || typeof text !== 'string') return '';
  const clean = text.replace(/\s+/g, ' ').trim();
  if (clean.length <= max) return clean;
  return `${clean.slice(0, max - 1).trim()}…`;
};

const SeoHead = ({
  title,
  description,
  canonicalPath,
  noindex = false,
  ogImage,
  ogType = 'website',
  jsonLd,
}) => {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const canonical = canonicalPath
    ? `${origin}${canonicalPath.startsWith('/') ? canonicalPath : `/${canonicalPath}`}`
    : typeof window !== 'undefined'
      ? `${origin}${window.location.pathname}`
      : undefined;

  const image = ogImage || (origin ? `${origin}/logo192.png` : undefined);
  const schemas = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={truncate(description)} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : null}

      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={truncate(description, 200)} /> : null}
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="Wownautic" />
      {image ? <meta property="og:image" content={image} /> : null}
      {image ? <meta property="og:image:alt" content={title || 'Wownautic'} /> : null}

      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={truncate(description, 200)} /> : null}
      {image ? <meta name="twitter:image" content={image} /> : null}

      {schemas.map((schema, index) => (
        <script key={`jsonld-${index}`} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SeoHead;
